import { createAppSlice } from "../../app/createAppSlice";

const initialState = {
    "id": null,
    "savedSearch": false,
    "source": "",
    "searchstring": "",
    "searchparameters": {},
    "autocheck": null,
    "datecreated": null,
    "lastcheckeddate": null,
    "label": {},
    "removed": null
};

const searchSettingsSlice = createAppSlice({
    name: "searchSettings",
    initialState,
    reducers: create => ({
        changeSearchSettings: create.reducer((state, action) => {
            let body = action.payload;
            //state.savedSearch = body.savedSearch || false;
            state.source = body.source;
            state.searchstring = body.searchstring;
            state.searchparameters = body.searchparameters;
        }),
    }),
    selectors: {
        selectSearchSettings: searchSettings => searchSettings
    },
})

export const { changeSearchSettings } = searchSettingsSlice.actions

export const { selectSearchSettings } = searchSettingsSlice.selectors

export default searchSettingsSlice